import { styled, css } from 'canoe';
import React from 'react';

const Container = styled.div<{ size: 'normal' | 'l' }>`
  ${({ theme, size }) => css`
    cursor: normal;
    bottom: 0px;
    padding: ${theme.spaces.normal} 0 0;
    width: 100%;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    ${size === 'l' &&
    css`
      position: absolute;
      bottom: -85px;
    `}
  `}
`;

const Button = styled.div<{ active: boolean; size: 'normal' | 'l' }>`
  ${({ theme, active, size }) => css`
    background-color: ${active ? theme.colors.AquaTeal : theme.colors.GlitterGray};
    cursor: pointer;
    border-radius: 50%;
    height: ${theme.spaces.s};
    margin-right: ${theme.spaces.xs};
    border: none;
    overflow: hidden;
    width: ${theme.spaces.s};

    ${size === 'l' &&
    css`
      width: 50px;
      height: 50px;
      margin-right: ${theme.spaces.l};
    `}
  `}
`;

interface Props {
  currentTooltip: number;
  tooltips: any;
  setTooltip: (index: number) => void;
  size: 'normal' | 'l';
}

export const TooltipCarousel = ({ currentTooltip, tooltips, setTooltip, size }: Props) => {
  return (
    <Container
      size={size}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {tooltips.map((tooltipId: any, index: number) => (
        <Button
          key={tooltipId}
          size={size}
          active={currentTooltip === index}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setTooltip(index);
          }}
        />
      ))}
    </Container>
  );
};
